<template>
  <section>
    <edit-sme-kyc
      is-create
      :is-fina="isFina"
      :form="form"/>
  </section>
</template>

<script>
import EditSmeKyc from './components/edit-sme-kyc'
import MixinFina from '@/mixins/fina'
import MixinRules from '@/mixins/rules'
export default {
  name: 'create-sme-ticket',
  components:{
    EditSmeKyc
  },
  mixins:[MixinFina,MixinRules],
  computed:{
    form(){
      let {classId} = this.$route.params
      return {
        class_id:classId
      }
    }
  },
  methods:{
  }
}
</script>

<style scoped>

</style>
